// extracted by mini-css-extract-plugin
export var closeButton = "_3d-3";
export var header = "_3d-0";
export var link = "_3d-1";
export var retryButton = "_3d-2";